<template>
  <div class="text-center page">
    <div v-if="unifiedorder && unifiedorder.product">
      <div class="item">
        <h2>{{unifiedorder.product.name}}</h2>
        <div class="image-wrapper">
          <img :src="weixinIcon" width="100px" height="100px"/>
        </div>
        <p>{{unifiedorder.product.description}}</p>
        <p>支付金额:&nbsp;<strong class="money">¥&nbsp;{{unifiedorder.product.price | currency}}&nbsp;元</strong></p>
        <p class="linear"></p>
        <p><a :href="unifiedorder.url" class="item-btn">立即购买</a></p>
      </div>
    </div>

    <div v-else class="loading-text">正在加载...</div>
  </div>
</template>

<script>
  import request from '@/utils/request';
  import weixinIcon from '@/images/shopImages/moreDiamonds.png';

  export default {
    name: 'ProductBuy',
    data () {
      return {
        unifiedorder: null,
        weixinIcon: weixinIcon
      };
    },
    created () {
      const params = this.$route.params;
      request.post('/api/wechat/unifiedorder', params).then((result) => {
        this.unifiedorder = result;
      }).catch(() => {
        this.$router.replace(`/wechat/callback/${params.orderId}/${params.token}`);
      });
    },

    methods: {
      formattedPrice (product) {
        if (product && product.price && product.discount) {
          return (parseInt(product.price) * parseInt(product.discount) / 100);
        }
      }
    }
  };
</script>

<style scoped>
  .page {
    height: 100%;
    background-color: rgb(236, 236, 236);
  }

  .item {
    padding: 10px;
  }

  .item h2, .item p, .item .image-wrapper {
    margin-top: 0;
    margin-bottom: 10px;
  }

  .item h2 {
    font-size: 20px;
    font-weight: 400;
  }

  .item p {
    font-size: 16px;
    color: #666666;
  }

  .item p:last-child {
    margin-bottom: 0;
  }

  .item p strong {
    line-height: 1;
    vertical-align: text-bottom;
  }

  .image-wrapper {
    background-color: rgb(255, 255, 255);
    border-radius: 5px;
    border: 1px solid #BBBBBB;
    line-height: 1;
  }

  .money {
    color: #EE6209;
    font-size: x-large;
  }

  .linear {
    border-bottom: thin dotted #BBBBBB;
  }

  .item-btn {
    display: block;
    height: 42px;
    line-height: 42px;
    color: #FFFFFF;
    text-align: center;
    border-radius: 5px;

    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #43C750), color-stop(1, #31AB40));
    border: 1px solid #2E993C;
    box-shadow: 0 1px 0 0 #69D273 inset;
  }

  .loading-text {
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// product.vue?193207f3